import { useState } from 'react';
import FinancialCTA from './FinancialCTA';
import FinancialChart from './FinancialChart';
import './financial-snapshot.scss';

const FinancialSnapshot = ({ userInfo, financialInfo, currency, setCurrency }) => {
  const [showCTA, setShowCTA] = useState(false);
  const { organization } = userInfo;

  return (
    <div className="financial-snapshot">
      <FinancialChart
        orgId={organization.id}
        financialInfo={financialInfo}
        showCTA={showCTA}
        onNoData={setShowCTA}
        currency={currency}
        setCurrency={setCurrency}
      />
      { showCTA && (
        <div className="invoice-landing">
          <FinancialCTA orgId={organization.id} />
        </div>
      )}
    </div>
  );
};

export default FinancialSnapshot;
